export const getCurrentCandidate = state => state.candidate || {}
